import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'GlobalNavigationBar',
  props: {
    selected: {
      type: String,
      default: ''
    },
    filters: {
      type: Array,
      required: true
    },
    navigateTo: {
      type: Function,
      required: true
    }
  },
  methods: {
    selectedStyle: function selectedStyle(_ref) {
      var tag = _ref.tag,
          color = _ref.color;

      if (this.selected === tag) {
        return {
          '--bg-color': color || 'hsla(60, 1%, 23%, 1)'
        };
      }

      return {
        '--bg-color': 'hsla(60, 1%, 23%, 1)'
      };
    },
    tracking: function tracking(category, action, label) {
      return {
        data: {
          event_category: category,
          event_action: action,
          event_label: label
        }
      };
    }
  }
};